import { LogisticaManifiestoProformaEstado } from "@pcgerente-node/pcg-comun";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { esNumeroOGuion } from "../../../Utils/regex";
import { buscarManifiestosProformas, limpiarConsultaSlice, limpiarManifiestoProformaSinLoading, obtenerCiudadesConsulta } from "../../../redux/actions/actionsConsulta";
import { RootState, useAppDispatch } from "../../../redux/store";
import "../../../styles/consultaGuia.css";
import Loading from "../../helpers/Loading/Loading";
import TablaManifiestosProforma from "./TablaManifiestosProforma";
import { StyleProps4, StyleProps5, StyleProps8, StylesProps3 } from "./styles";

interface ChildsProps{
  autenticado: boolean
}

const ConsultaGuiaContent: React.FC<ChildsProps> = ({autenticado}) => {

  const manifiestosStore = useSelector((state: RootState) => state.consulta.manifiestosProformasConsulta)
  const ciudadesStore = useSelector((state: RootState) => state.consulta.ciudadesConsulta)
  const usuarioVM = useSelector((state: RootState) => state.auth.usuarioActual)
  
  const dispatch = useAppDispatch()
  const [yaHaBuscado, setYaHaBuscado] = useState(false)

  let fechaActualFormateada = new Date().toISOString()
  fechaActualFormateada = fechaActualFormateada.slice(0, fechaActualFormateada.indexOf("T"))

  let fechaAnterior = new Date(new Date().setMonth(new Date().getMonth() - 1)).toISOString()
  fechaAnterior = fechaAnterior.slice(0, fechaAnterior.indexOf("T"));

  const initialStateQuery = {
    desde: fechaAnterior,
    hasta: fechaActualFormateada,
    numeroManifiesto: "",
    estado: LogisticaManifiestoProformaEstado.Todos,
    error: ""
  }
  const [query, setQuery] = useState(initialStateQuery)
 
  //La primera vez que carga la página nos traemmos la información base
 useEffect(() => {
  dispatch(obtenerCiudadesConsulta())
// eslint-disable-next-line react-hooks/exhaustive-deps
}, [])

  return (
    
    <div id="content" className="main-content">
      <div className="layout-px-spacing">
        <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
          <div className="col-sm-12 text-center">
            <h3 style={StyleProps5}>Consulta de Resumenes de Guias</h3>
          </div>

          <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 layout-spacing">
            <form className="form-inline" onSubmit={(e) => e.preventDefault()}>

              <div className="input-group mb-2 col-sm-4">
                <div className="input-group-prepend">
                  <div className="input-group-text" style={StylesProps3}>#Manifiesto:</div>
                </div>
                <input
                  type="text"
                  className="form-control"
                  id="inlineFormInputGroupUsername2"
                  value={query.numeroManifiesto}
                  onKeyDown={(e) =>handleEnter(e, true)}
                  onChange={(e) => handleQuery(e, "numeroManifiesto")}
                />
              </div>

              <div className="input-group mb-2 col-sm-4">
                <div className="input-group-prepend">
                  <div className="input-group-text" style={StylesProps3}>Desde</div>
                  <input
                    type="date"
                    className="form-control"
                    id="date"
                    value={query.desde}
                    onChange={(e) => handleQuery(e, "desde")}
                  />
                </div>
              </div>

              <div className="input-group mb-2 col-sm-4">
                <div className="input-group-prepend">
                  <div className="input-group-text" style={StylesProps3}>Hasta</div>
                  <input
                    type="date"
                    className="form-control"
                    id="date"
                    value={query.hasta}
                    onChange={(e) => handleQuery(e, "hasta")}
                  />
                </div>
              </div>
              
              <div className="input-group mb-2 mr-sm-4 col-sm-4">
                <div className="input-group-prepend">
                  <div className="input-group-text" style={StylesProps3}>Estado</div>
                </div>
                <select className=" form-control-plaintext"
                  style={StyleProps4}
                  color="white"
                  value={query.estado}
                  onChange={(e) => handleQuery(e, "estado")}
                >
                  <option hidden value="">Buscar por estado</option>
                  <option value={LogisticaManifiestoProformaEstado.Todos}>Todos</option>
                  <option value={LogisticaManifiestoProformaEstado.Pendiente}>Pendiente</option>
                  <option value={LogisticaManifiestoProformaEstado.Convertido}>Convertido</option>
                  <option value={LogisticaManifiestoProformaEstado.Anulado}>Anulado</option>
                </select>
              </div>


              <div className="col-sm-12 text-center">
                  <button
                    onClick={() => restablecerFiltrado()}
                    className="btn btn-danger col-sm-3 mb-2"
                    style={StyleProps8}
                    disabled={yaHaBuscado?(manifiestosStore.loading || ciudadesStore.loading): false}
                    >
                    restablecer
                  </button>

                  <button
                    name="search"
                    className="btn btn-primary btn-block- col-sm-3 mb-2"
                    onClick={() => buscarManifiestos(true)}
                    disabled={yaHaBuscado?(manifiestosStore.loading || ciudadesStore.loading): false}
                    >
                    Buscar
                  </button>
              </div>
            </form>
          </div>
        </div>

        <div className="col-xl-12 col-sm-12 col-12 layout-spacing">
          <div className="widget-content">
              <div className="d-flex justify-content-center mt-2 mb-2">
                <span className="text-danger" style={{fontSize: "1.2rem"}}>{query.error}</span>
              </div>
              {manifiestosStore.errorUndefined?
                  <div className="d-flex align-items-center flex-column">
                    <button className="d-flex btn btn-primary mb-3 mt-2" onClick={() => limpiarRedux()}>Reintentar</button>
                    <span className="d-flex text-center">Ha ocurrido un error</span>
                  </div>
                : yaHaBuscado === false? //Si aún el usuario no realiza una búsqueda
                <div className="d-flex justify-content-center">
                  <span className="text-center pt-2" style={{ fontSize: "1.5rem" }}>Aún no se ha realizado una búsqueda</span>
                </div>
                :
                    manifiestosStore.loading ===false && ciudadesStore.loading === false? //si ya termino de cargar
                    manifiestosStore.info.length>0 && ciudadesStore.info.length > 0 ? 
                        //Si hay contenido
                        <div className="table-responsive justify-content-center">
                            <TablaManifiestosProforma 
                            manifiestosProforma={manifiestosStore.info} 
                            ciudades = {ciudadesStore.info}
                            />
                        </div>
                        ://Por si no hay contenido
                        <div className="d-flex justify-content-center">
                          <span className="text-center text-danger" style={{ fontSize: "1.5rem" }}>{query.error?"":"No se econtraron resumenes de guias"}</span>
                        </div>
                    : <Loading /> //si no termino de cargar
                  }
            </div>
          </div>
        </div>
      </div>
  )

  
  function handleQuery(e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>, type: string) {
    if (type === "desde") {
      setQuery({
        ...query,
        desde: e.target.value
      })
    }
    if (type === "hasta") {
      setQuery({
        ...query,
        hasta: e.target.value
      })
    }

    if (type === "estado") {
      setQuery({
        ...query,
        estado: e.target.value as LogisticaManifiestoProformaEstado
      })
    }
    
    if (type === "numeroManifiesto"  && (esNumeroOGuion(e.target.value) || e.target.value === "" )) {
      setQuery({
        ...query,
        numeroManifiesto: e.target.value,
        error: ""
      })
    }
  }

  function restablecerFiltrado() {
    setQuery(initialStateQuery)
  }

  function buscarManifiestos(limpiarmMaifiestos: boolean) {
    let puedeBuscar = true 
    const consManifiesto = query.numeroManifiesto.split("-")

    if(autenticado === false && consManifiesto.length !== 3){
      setQuery({
        ...query,
        error: "Debe Ingresar un número de Manifiesto con el formato: ###-###-###"
      })
      puedeBuscar = false
    }
    if(consManifiesto.length !== 3 && query.numeroManifiesto.length>0){
      setQuery({
        ...query,
        error: "Error: El formato de #Manifiesto debe ser: ###-###-###"
      })
      puedeBuscar = false
    }
    if(yaHaBuscado === false){
      setYaHaBuscado(true)
    }
    if(puedeBuscar){ 
      if (limpiarmMaifiestos) {
        limpiarRedux()
        dispatch(obtenerCiudadesConsulta())
      }
      dispatch(buscarManifiestosProformas(
        query.desde, 
        query.hasta, 
        query.estado,
        consManifiesto[0]||"", 
        consManifiesto[1]||"",
        Number(consManifiesto[2])||0,
        usuarioVM._ItemActivo.id))
    }else{//puede guardar
      dispatch(limpiarManifiestoProformaSinLoading())
    }


  }

  function limpiarRedux() {
    dispatch(limpiarConsultaSlice("guias"))
  }

  function handleEnter(e: React.KeyboardEvent<HTMLInputElement>, puedeBuscar: boolean) {
    if (e.key === "Enter") {
      e.preventDefault()
      if (manifiestosStore.loading === false && puedeBuscar)
        buscarManifiestos(false)
    }
  }
}


export default ConsultaGuiaContent